export default __webpack_public_path__ + "static/media/athelasLogo.832dbf0a.png";